import { useMemo } from 'react'

import { FormConfig } from '../../state/configuration'
import { isInputConfig } from './config'
import { FormData } from './types'

export const useDataWithDefaultValues = (config: FormConfig, data: FormData) => {
  return useMemo(() => {
    const defaults = Object.fromEntries(
      config.filter(isInputConfig).map((it) => [it.name, it.defaultValue ?? null]),
    )

    return { ...defaults, ...data }
  }, [data])
}
